document.addEventListener("DOMContentLoaded", () => {
	$(document).off("change.collapseTarget").on("change.collapseTarget", "input[data-collapse-target]", function () {
		$(this.dataset.collapseTarget).collapse(this.checked ? "show" : "hide");
	});

	$(".form-cart-data-submit").off("click").on("click", function (e) {
		$("input[type=\"submit\"][name=\"send\"]").click();
		e.preventDefault();
		e.stopPropagation();
	});

	$(".delivery-option").off("click").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		$(".delivery-option").removeClass("selected");
		$(this).addClass("selected");
		$(this).find("input").prop("checked", true);

		$(".payment-option").removeClass("selected").addClass("d-none");
		$(".payment-option input[type=\"radio\"]").prop("checked", false);

		const acceptablePaymentIds = $(this).data("payment-ids");

		for (let acceptablePaymentId in acceptablePaymentIds) {
			if (acceptablePaymentIds.hasOwnProperty(acceptablePaymentId)) {
				const paymentOption = $("[data-payment-id=\"" + acceptablePaymentIds[acceptablePaymentId] + "\"]");
				paymentOption.removeClass("d-none");
			}
		}

		if ($(this).hasClass("dpd-open")) {
			showDpdWidget();
		}

		$('.alert-select-delivery').fadeOut(250, function () {
			$('.list-group-select-delivery').fadeIn(250)
		})
	});

	$(".payment-option").off("click").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		$(".payment-option").removeClass("selected");
		$(this).addClass("selected");
		$(this).find("input").prop("checked", true);
	});

	$(".extra-option").off("click").on("click", function (e) {
		e.preventDefault();
		e.stopPropagation();

		if ($(this).find("input").is(":checked")) {
			$(this).removeClass("selected");
			$(this).find("input").prop("checked", false);
		} else {
			$(this).addClass("selected");
			$(this).find("input").prop("checked", true);
		}
	});

	function showDpdWidget()
	{
		const $modal = $("#dpd-modal")
		$modal.modal('show');

		window.addEventListener("message", (event) => {
			if(event.data.dpdWidget) {
				if (event.data.dpdWidget.message === "widgetClose") {
					$modal.modal('hide')
				} else {
					const point = event.data.dpdWidget;
					const name = point.contactInfo.name + ", " + point.location.address.street + ", " + point.location.address.zip + " " + point.location.address.city;
					const id = point.id;

					$(".packeta-branch-name").html(name);
					$("input[name=\"vm_name\"]").val(name);
					$("input[name=\"vm_code\"]").val(id);

					$modal.modal('hide')
				}
			}
		}, false);
	}
});
